var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`dk-badge dk-badge--${_vm.size} d--inline-block`},[_c('span',{class:_vm.classes},[(_vm.hasIcon)?_c('icon',{staticClass:"m-right--xxs dk-badge__icon",attrs:{"name":_vm.options.icon,"color":_vm.options.color}}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }